import { render, staticRenderFns } from "./MyConsumption.vue?vue&type=template&id=12c2750e"
import script from "./MyConsumption.vue?vue&type=script&lang=js"
export * from "./MyConsumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports